import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons/faCalendarAlt";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons/faTimesCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as tokens from "@shape-ds/tokens";

import { DatePicker, ConfigProvider, theme } from "antd";
import type { GetProps } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

const { RangePicker } = DatePicker;

export type Props = GetProps<typeof DatePicker.RangePicker>;

const DateRangePicker = ({
  allowClear = false,
  className,
  format = "DD/MM/YYYY",
  defaultValue,
  defaultPickerValue,
  disabled,
  disabledDate,
  onCalendarChange,
  onChange,
  onOpenChange,
  placeholder = ["Start", "End"],
  size = "large",
  suffixIcon,
  clearIcon,
  value,
  renderExtraFooter,
  picker,
}: Props) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorText: tokens.darkColors.GRAY_7,
          colorIcon: tokens.darkColors.GRAY_7,
          colorBgContainer: "transparent",
          colorBorder: tokens.darkColors.GRAY_5,
          colorTextDisabled: tokens.darkColors.GRAY_4,
          colorTextPlaceholder: tokens.darkColors.GRAY_4,
        },
        components: {
          DatePicker: {
            colorBgElevated: tokens.darkColors.GRAY_2,
            cellHoverWithRangeBg: tokens.darkColors.GRAY_5,
            cellActiveWithRangeBg: tokens.darkColors.GRAY_5,
            activeShadow: "none",
          },
        },
      }}
    >
      <RangePicker
        allowClear={allowClear}
        className={className}
        defaultValue={defaultValue}
        defaultPickerValue={defaultPickerValue}
        disabled={disabled}
        disabledDate={disabledDate}
        format={format}
        onCalendarChange={onCalendarChange}
        onChange={onChange}
        onOpenChange={onOpenChange}
        placeholder={placeholder}
        size={size}
        clearIcon={
          clearIcon || (
            <FontAwesomeIcon icon={faTimesCircle} className="fa-md" />
          )
        }
        suffixIcon={
          suffixIcon || (
            <FontAwesomeIcon icon={faCalendarAlt} className="fa-md" />
          )
        }
        value={value}
        renderExtraFooter={renderExtraFooter}
        picker={picker}
      />
    </ConfigProvider>
  );
};

export default DateRangePicker;
